<template>
  <mds-modal actionRequired="true" aria-label="Upload Modal" v-model:visible="toggle" width="100%">
    <mds-button-container style="margin-bottom: 0.5%; text-align: end">
      <mds-button type="button" @click="toggle = !toggle" :disabled="showModelLoader" variation="icon-only"
        icon="remove">Close</mds-button>
    </mds-button-container>
    <FileUpload v-if="toggle" :eventIdProp="eventIdProp" :uploadedDetails="uploadedDetails"
      :eventNameProp="eventNameProp" @showModelLoader="handleshowModelLoader" @updateDetails="handleUpdateDetails">
    </FileUpload>
  </mds-modal>
  <mds-modal aria-label="Loader Modal" actionRequired="true" v-model:visible="showModelLoader" size="small"
    style="width: 7%; height: auto; background-color: white; border: 0px">
    <ModelLoader></ModelLoader>
  </mds-modal>
  <mds-alert v-if="showAlert" v-bind:variation="alertVariation" v-bind:title="alertTitle" tinted
    @mds-alert-dismissed="closeAlert">
    {{ alertMessage }}
  </mds-alert>
  <!-----------CommentModalToggle Comment Modal Section ---------->

  <mds-modal style="width: 20%;padding: 5px;" actionRequired="true" aria-label="Upload Modal" v-model:visible="CommentModalToggle"
    width="40%">
    <div style="display: flex; flex-direction: column; gap: 10px;">    
    <mds-button-container style="margin-bottom: 0.5%; text-align: end">
      <mds-button type="button" @click="CommentModalToggle = !CommentModalToggle" :disabled="showModelLoader"
        variation="icon-only" icon="remove">Close</mds-button>
    </mds-button-container>
    <textarea v-model="commentText" placeholder="Enter your comment here" style="width: 100%; height: 100px; padding: 10px; border-radius: 4px;border: 1px solid #ccc; font-size: 0.8rem; font-family: inherit; color: #333; white-space: pre-wrap;
      word-wrap: break-word; overflow-wrap: break-word; overflow-x: hidden; resize: none; box-sizing: border-box;"
      @input="commentText = commentText.replace(/[^a-zA-Z0-9\s,.-]/g, '')">
      </textarea>
    <mds-button-container style="margin-bottom: 0.5%; text-align: end">
      <mds-button type="button" @click="OnCommentSubmit" :disabled="showModelLoader"
        variation="primary">Submit</mds-button>
    </mds-button-container>
    </div>
  </mds-modal>

  <!-----------CommentModalToggle Comment Modal Section ---------->

  <mds-modal aria-label="Event Action Log" actionRequired="true" v-model:visible="showActionLogModal" width="70%">
    <mds-button-container style="margin-bottom: 0.5%; text-align: end">
      <mds-button type="button" @click="showActionLogModal = false" :disabled="showModelLoader || actionLogLoading" variation="icon-only" icon="remove">Close</mds-button>
    </mds-button-container>
    <div v-if="actionLogLoading" style="padding:8px;">
      <mds-loader size="small" aria-label="Loading Action Log"></mds-loader>
    </div>
    <div v-else-if="actionLog.length === 0">
      <p style="font-size:0.8rem;">No action logs found.</p>
    </div>
    <div v-else style="overflow-x:auto;">
      <mds-table zebra-stripes>
        <mds-thead>
          <mds-th style="width:8%">Event ID</mds-th>
          <mds-th style="width:10%">Company Id</mds-th>
          <mds-th style="width:12%">DA Name</mds-th>
          <mds-th style="width:24%">Action Performed</mds-th>
          <mds-th style="width:30%">Detail</mds-th>
          <mds-th style="width:16%">Created Date(UTC)</mds-th>
        </mds-thead>
        <mds-tbody>
          <mds-tr v-for="(log, idx) in actionLog" :key="idx">
            <mds-td>{{ log.eventID  }}</mds-td>
            <mds-td>{{ log.companyId }}</mds-td>
            <mds-td>{{ log.user }}</mds-td>
            <mds-td>{{ log.actionPerformed }}</mds-td>
            <mds-td style="word-break: break-word; white-space: pre-wrap; max-width: 350px;">{{ log.detail }}</mds-td>
            <mds-td>{{ formatActionDate(log.createdDate) }}</mds-td>
          </mds-tr>
        </mds-tbody>
      </mds-table>
      <div style="margin-top:8px;" v-if="showActionLogPagination">
        <mds-pagination
          :total-items="totalActionLogCount"
          :pageSizes="actionLogPageSizes"
          :page="actionLogPageIndex"
          :page-size="actionLogPageSize"
          show-items-info
          show-items-select
          @mds-pagination-page-changed="handleActionLogPageChange"
        ></mds-pagination>
      </div>
    </div>
  </mds-modal>
  <!-----------MismatchedModalToggle Mismatched Confirmation Modal Section ---------->
  <mds-modal style="width: 25%; padding: 20px;" actionRequired="true" aria-label="Mismatched Confirmation Modal" v-model:visible="MismatchedModalToggle" width="40%">
    <div style="display: flex; flex-direction: column; gap: 15px; text-align: center;">    
      <h3 style="margin: 0; color: #333;">Match Confirmation</h3>
      <p style="margin: 10px 0; font-size: 1rem; color: #666;">
       <strong>The transcript does not match the company.<br>Do you still want to proceed?</strong><br><br>
        <strong>Company Id:</strong> {{ selectedMismatchedEvent?.companyId }}<br>
        <strong>Event Id:</strong> {{ selectedMismatchedEvent?.eventId }}<br>
        <strong>Job Id:</strong> {{ selectedMismatchedEvent?.jobId }}
      </p>
      <mds-button-container style="display: flex; gap: 10px; justify-content: center;">
        <mds-button type="button" @click="confirmMatch" :disabled="showModelLoader" variation="primary">Proceed</mds-button>
        <mds-button type="button" @click="cancelMatch" :disabled="showModelLoader" variation="secondary">Cancel</mds-button>
      </mds-button-container>
    </div>
  </mds-modal>
  <!-----------MismatchedModalToggle Mismatched Confirmation Modal Section ---------->

  <mds-card style="width: 100%; margin-top: 1%; min-height: 80vh; min-width: 1400px;" title="Conference Call Tracker"
    caption="Select Filter and View Conference Call Details here">
    <template #mds-card-action>
      <mds-form>
         <mds-fieldset id="fsFilter" style="display: flex; flex-wrap: wrap; gap: 1rem;margin-bottom: 10px;">
          <mds-input
            style="min-width:120px"
            id="inComapnyId"
            label="Company Id"
            v-model="CompanyId"
          ></mds-input>
          <mds-input
            style="min-width:120px"
            id="inEventId"
            label="Event Id"
            v-model="EventId"
          ></mds-input>
          <mds-combo-box
              label="EventType"
              multiple
              v-model="selectedDefaultOptions"
              :data-set="defaultDataSet"
          ></mds-combo-box>
          <mds-combo-box
            label="Priority"
            multiple
            v-model="Priority"
            :data-set="[
              { text: '1', value: '1' },
              { text: '2', value: '2' },
              { text: '3', value: '3' },
              { text: '4', value: '4' },
              { text: '5', value: '5' },
              { text: '6', value: '6' },
              { text: '7', value: '7' },
              { text: '99', value: '99' },
              { text: 'NA', value: 'NA' },
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="FFPriority"
            multiple
            v-model="FFPriority"
            :data-set="this.FFPriorityList"
          ></mds-combo-box>
          <mds-date-picker
            style="min-width:150px"
            label="Begin Date"
            v-model="StartDate"
            :min-max-dates="{
              min: new Date(2000, 0, 1),
              max: new Date(2099, 11, 31)
            }"
            :labels="{ month: 'short' }"
            :date-format="{ month: 'short' }"
            readonly
          ></mds-date-picker>
          <mds-date-picker
            style="min-width:150px"
            label="End Date"
            v-model="EndDate"
            :min-max-dates="{
              min: new Date(2000, 0, 1),
              max: new Date(2099, 11, 31)
            }"
            :labels="{ month: 'short' }"
            :date-format="{ month: 'short' }"
            readonly
          ></mds-date-picker>
          <mds-combo-box
            label="Replay Available"
            multiple
            v-model="IsReplayAvailable"
            :data-set="[
              { text: 'Yes', value: 'true' },
              { text: 'No', value: 'false' },
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="Presentation Available"
            multiple
            v-model="IsPresentationAvailable"
            :data-set="[
              { text: 'Yes', value: 'true' },
              { text: 'No', value: 'false' },
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="Job Status"
            v-model="JobIdStatus"
            style="min-width:260px"
            multiple
            :data-set="[
              { text: 'Select All', value: 'selectAll' },
              { text: 'Blank', value: 'Blank' },
              { text: 'JOB_CREATED', value: '1' },
              { text: 'JOB_CREATION_FAILED', value: '2' },
              { text: 'BATCH_JOB_SUBMITTED', value: '3' },
              { text: 'BATCH_JOB_SUBMISSION_FAILED', value: '4' },
              { text: 'AUDIO_CONVERSION_SKIPPED', value: '5' },
              { text: 'AUDIO_CONVERSION_COMPLETED', value: '6' },
              { text: 'AUDIO_CONVERSION_FAILED', value: '7' },
              { text: 'AUDIO_RECORDER_COMPLETED', value: '8' },
              { text: 'AUDIO_RECORDER_FAILED', value: '9' },
              { text: 'WHISPER_GET_RESPONSE_RECEIVED', value: '10' },
              { text: 'WHISPER_GET_RESPONSE_FAILED', value: '11' },
              { text: 'PYANNOTE_DIARIZATION_COMPLETED', value: '12' },
              { text: 'PYANNOTE_DIARIZATION_FAILED', value: '13' },
              { text: 'TRANSCRIPTION_PROCESSOR_SUCCESS', value: '14' },
              { text: 'TRANSCRIPTION_PROCESSOR_FAILED', value: '15' },
            ]"
          ></mds-combo-box>
            <mds-combo-box
              label="Note Types"
              v-model="NoteType"
              multiple
              :data-set="commentNoteDataSet"
            ></mds-combo-box>
            <mds-combo-box label="Match Status" v-model="MatchStatus" multiple :data-set="[
              { text: 'Matched', value: 'Matched' },
              { text: 'Mismatched', value: 'Mismatched' }
            ]"></mds-combo-box>
            <mds-combo-box
              label="Event Countdown"
              v-model="selectedTimeFilter"
              @mds-combo-box-change="onEventCountdownChange"
              :data-set="[
                { text: '1hr', value: '1' },
                { text: '3hr', value: '3' },
                { text: '5hr', value: '5' },
                { text: '8hr', value: '8' },
                { text: '12hr', value: '12' }
              ]"
            ></mds-combo-box>
        </mds-fieldset>
        
        <div style="display: flex;">
        <mds-button
          size="medium"
          variation="primary" icon="search" 
          v-on:click.prevent="getEvents(true)"
        >
          Search
        </mds-button>

        <mds-button style="margin-left: 10px" size="medium" variation="primary" icon="refresh"
          v-on:click.prevent="refreshEvent()">
          Refresh
        </mds-button>
        <mds-button style="margin-left: 10px" size="medium" variation="primary" icon="download"
          v-on:click.prevent="exportEvents()">
          Export
        </mds-button>
      </div>
      </mds-form>
      <div>
        <mds-loader
          size="large"
          aria-label="Large Loader"
          v-if="showLoader"
        ></mds-loader>
        <mds-pagination
          v-if="showPagination"
          show-items-info
          show-items-select
          :total-items="totalRecord"
          @mds-pagination-page-changed="handlePageChange"
          :pageSizes="paginationPageSize"
          :page="paginationOptions.page"
        ></mds-pagination>
        <div style="overflow-x: auto; width: 100%;">
        <div style="min-width: 2050px;">
        <mds-table zebra-stripes>
          <mds-thead>
            <mds-th style="width: 6%"> Event Id </mds-th>
            <mds-th style="width: 15%"> Event Name </mds-th>
            <mds-th style="width: 9%"> Company Id </mds-th>
            <mds-th style="width: 12%"> Event Type </mds-th>
            <mds-th style="width: 10%"> Beginning Date
              <button @click="getSortedData($event)" value="beginingDateDesc"><img
                  src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14" /></button>
              <button @click="getSortedData($event)" value="beginingDateAsc"><img
                  src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14" /></button></mds-th>
            <mds-th style="width: 5%"> Time </mds-th>
            <mds-th style="width: 7%"> IST DateTime 
              <button @click="getSortedData($event)" value="istDateDesc"><img src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14"/></button>
              <button @click="getSortedData($event)" value="istDateAsc"><img src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14"/></button></mds-th>
            <mds-th style="width: 7%"> Priority 
              <button @click="getSortedData($event)" value="priorityDesc"><img src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14"/></button>
              <button @click="getSortedData($event)" value="priorityAsc"><img src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14"/></button></mds-th>
            <mds-th style="width: 7%"> FFPriority </mds-th>
            <mds-th style="width: 7%"> Replay Available </mds-th>
            <mds-th style="width: 6%"> Event Details URL </mds-th>
            <mds-th style="width: 6%"> Webcast URL </mds-th>
            <mds-th style="width: 13%"> Source of Webcast 
            <button @click="getSortedData($event)" value="domainDesc"><img src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14"/></button>
              <button @click="getSortedData($event)" value="domainAsc"><img src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14"/></button></mds-th>
            <mds-th style="width: 10%"> JobId </mds-th>
            <mds-th style="width: 9%"> Job Status 
              <button @click="getSortedData($event)" value="jobStatusDesc"><img src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14"/></button>
              <button @click="getSortedData($event)" value="jobStatusAsc"><img src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14"/></button></mds-th>
            <mds-th style="width: 5%"> Action </mds-th>
            <mds-th style="width: 9%"> PPT Doc Id </mds-th>
            <mds-th style="width: 30%"> Edit DocId </mds-th>
            <mds-th style="width: 12%"> Note </mds-th>
            <mds-th style="width: 12%"> Match Status </mds-th>
          </mds-thead>
          <mds-tbody>
            <mds-tr v-for="(event, eventItemIndex) in eventList" :key="event.userid">
              <mds-td> {{ event.eventId }} </mds-td>
              <mds-td> {{ event.eventName }} </mds-td>
              <mds-td>
                <a
                  style="cursor: pointer; text-decoration: underline; color: #0066cc;"
                  @click="fetchCompanyUrls(event.companyId)"
                  :title="'View URLs for Company ' + event.companyId"
                >{{ event.companyId }}</a>
              </mds-td>
              <mds-td>
                <a
                  style="cursor: pointer; text-decoration: underline"
                  @click="fetchEventActionLog(event.eventId)"
                  :title="'View action log for Event ' + event.eventId"
                >{{ event.eventType }}</a>
              </mds-td>
              <mds-td> {{ formatDate(event.beginingDate) }} </mds-td>
              <mds-td> {{ event.time }} </mds-td>
              <mds-td> {{ formatISTDate(event.istDate) }} </mds-td>
              <mds-td> {{ event.priority }} </mds-td>
              <mds-td> {{ event.ffPriority }} </mds-td>
              <mds-td>
                {{
                  event.isReplayAvailable == true
                    ? "Yes"
                    : event.isReplayAvailable == false
                      ? "No"
                      : event.isReplayAvailable
                }}
              </mds-td>
              <mds-td
                ><a
                  style="cursor: pointer"
                  v-bind:title="event.eventDetailUrl"
                  @click="openUrl(event.eventDetailUrl)"
                  v-if="event.eventDetailUrl != ''"
                  >View Url</a
                ></mds-td
              >
              <mds-td
                ><a
                  style="cursor: pointer"
                  v-bind:title="event.webcastUrl"
                  @click="openUrl(event.webcastUrl)"
                  v-if="event.webcastUrl != ''"
                  >View Url</a
                ></mds-td
              >
              <mds-td> {{ event.domain }} </mds-td>
              <mds-td style="word-wrap: break-word" :id="JobRowID + eventItemIndex">
                {{ event.jobId }}
              </mds-td>
              <mds-td style="word-wrap: break-word">
                {{ event.jobStatus }}
              </mds-td>


              <mds-td style="width: 42%">
                <label :class="$style['toggle-switch']">
                  <input type="checkbox" v-model="event.isEditing" />
                  <span :class="[$style.slider, $style.round]"></span>
                </label>
                <span style="margin-left: 8px;">{{ event.isEditing ? 'On' : 'Off' }}</span>
              </mds-td>



              <textarea v-model="event.textValue" :disabled="!event.isEditing" placeholder="Enter Doc IDs"
                @input="event.textValue = event.textValue.replace(/[^0-9,]/g, '')" style="
    width: 100%;
    height: 100px;
    padding: 10px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-family: inherit;
    color: #333;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
    overflow-x: hidden;
    resize: none;
    box-sizing: border-box;"></textarea>


              <mds-td>
                <mds-table>
                  <mds-tr style="width: 100%">
                    <mds-td style="width: 20%">
                      <mds-button variation="primary"
                        v-on:click="saveStatus(eventItemIndex, event.eventId, event.textValue)"
                        size="small">Save</mds-button>
                    </mds-td>


                    <mds-td mds-td style="width: 50%">
                      <input type="File" :id="TranscribeFileInput + eventItemIndex" hidden ref="fileInput"
                        style="background-color: #e5e5e5; width: 70%" @change="handleFileChange" />
                      <mds-input :id="TranscribeFile + eventItemIndex" style="background-color: #e5e5e5; color: black"
                        placeholder="Choose Manual File" readonly v-on:click.prevent="chooseFiles(eventItemIndex)"
                        size="medium"></mds-input></mds-td>
                    <mds-td style="width: 40%">
                      <mds-button :id="TranscribeButton + eventItemIndex" variation="primary" v-on:click="
                        UploadTranscribe(
                          event.priority,
                          eventItemIndex,
                          event.eventId,
                          event.eventType,
                          event.companyId,
                          event.companyName,
                          event.beginingDate
                        )
                        " disabled size="small">Transcribe</mds-button>
                    </mds-td>
                  </mds-tr>
                </mds-table>
              </mds-td>
              <mds-td>
                <div :class="$style['hover-box']">
                  <mds-select v-bind:value="event.commentNoteId" :id="NoteId + eventItemIndex"
                    @change="NoteChanged(event,eventItemIndex, event.eventId)" @mouseover="toggleTooltip($event, true, eventItemIndex, event.eventId)"
                    @mouseleave="toggleTooltip($event, false, eventItemIndex, event.eventId)" placeholder="Select an Option" :options="commentNoteOptions"></mds-select>
                  <div :class="$style['tooltip']" :style="{ top: tooltipPosition.top + 'px', left: tooltipPosition.left + 'px' }" :data-value="event.comment" :id="CommentId + eventItemIndex" v-if="showTooltip && showTooltipId == NoteId+eventItemIndex && event.commentNote === 'Other'">
                    {{event.comment}}
                  </div>
                </div>
              </mds-td>
              <mds-td style="word-wrap: break-word">
                <span v-if="event.isMatched === 'Mismatched'" @click="openMismatchedModal(event)" style="cursor: pointer; color: #d32f2f; text-decoration: underline; font-weight: bold;" title="Click to match this event">{{ event.isMatched }}</span><span v-else style="color: #4caf50; font-weight: bold;">{{ event.isMatched }}</span>
              </mds-td>
            </mds-tr>
          </mds-tbody>
        </mds-table>
        </div>
        </div>
      </div>
    </template>
  </mds-card>
</template>

<script>
import axiosInstance from "@/AxiosTokenInstance";
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table-vue3";
import MdsForm from "@mds/form-vue3";
import MdsCard from "@mds/card-vue3";
import MdsComboBox from "@mds/combo-box-vue3";
import MdsInput from "@mds/input-vue3";
import MdsSelect from "@mds/select-vue3";
import MdsFieldset from "@mds/fieldset-vue3";
import { MdsButton } from "@mds/button-vue3";
import MdsDatePicker from "@mds/date-picker-vue3";
import { mapState, mapActions, mapMutations } from "vuex";
import MdsLoader from "@mds/loader-vue3";
import MdsPagination from "@mds/pagination-vue3";
import { ref, watch } from "vue";
import moment, * as moments from "moment";
import MdsModal from "@mds/modal-vue3";
import FileUpload from "../ConferenceCallTracker/FileUpload.vue";
import ModelLoader from "../ModelLoader.vue";
import MdsAlert from "@mds/alert-vue3";
import config from "../../config";
import { saveAs } from 'file-saver';
export default {
  name: "ConferenceCallDetails",
  components: {
    MdsCard,
    MdsForm,
    MdsComboBox,
    MdsSelect,
    MdsInput,
    MdsFieldset,
    MdsButton,
    MdsDatePicker,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsLoader,
    MdsPagination,
    FileUpload,
    MdsModal,
    ModelLoader,
    MdsAlert,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      paginationPageSize: [10, 20, 30, 40, 50, 100],
      eventList: [],
      showLoader: false,
      toggle: false,
      showTooltip: false,
      CommentModalToggle: false,
      MismatchedModalToggle: false,
      showModelLoader: false,
      showTooltipId: "",
      tooltipPosition: { top: 0, left: 0 },
      commentText: "",
      selectedMismatchedEvent: null,
      eventIdProp: "",
      CompanyId: "",
      EventId: "",
      StartDate: "",
      EndDate: "",
      Priority: [],
      FFPriority: [],
      IsReplayAvailable: [],
      IsPresentationAvailable: [],
      CollectionStatus: [],
      Note: [],
      paginationOptions: {
        page: 1,
      },
      DefaultPageIndex: 1,
      DefaultPageSize: 10,
      totalRecord: "",
      NoteId: "NoteId",
      CommentId:"CommentId",
      EventStatus: {},
      EventComment: {},
      showAlert: false,
      alertTitle: "",
      alertMessage: "",
      alertVariation: "",
      uploadedDetails: [],
      webcastUrl: "",
      alertTimer: "",
      showPagination: false,
      TranscribeFile: "TranscribeFile",
      TranscribeFileInput: "TranscribeFileInput",
      TranscribeButton: "TranscribeButton",
      JobRowID: "JobRowID",
      selectedFile: null,
      chooseFile: "",
      currentFileIndex: 0,
      lastFileSelected: null,
      eventNameProp: "",
      selectecEventTypes: [],
      EventTypes: [],
      JobIdStatus: [],
      NoteType:[],
      MatchStatus:[],
      sortInfo: "",
      sort:"",
      FFPriorityList:config.ffPriorityList.split(",").map(a => ({text:a,value:a})),
      selectedTimeFilter: null,
      commentNoteStatuses: [],
      isDataReady: false,
      showActionLogModal:false,
      actionLog:[],
      totalActionLogCount:0,
      currentActionLogEventId:null,
      actionLogPageIndex:1,
      actionLogPageSize:5,
      actionLogPageSizes:[5,10,20,30,50],
      showActionLogPagination:false,
      actionLogLoading:false,
      selectedDefaultOptions: [],
      updatingSelection: false,
      selectAllChecked: false,
      earningsParentChecked: false,
      nonEarningsParentChecked: false,
      isClearingAll: false,
      // Special values for parent selections
      SPECIAL_VALUES: {
        SELECT_ALL: '__SELECT_ALL__',
        EARNINGS_PARENT: '__EARNINGS_PARENT__',
        NON_EARNINGS_PARENT: '__NON_EARNINGS_PARENT__'
      },
      // Event type value groupings (from config)
      earningsValues: config.earningsValues || [],
      nonEarningsValues: config.nonEarningsValues || [],
      allDefaultValues: config.allDefaultValues || [],
      defaultDataSet: config.defaultDataSet || [],
    };
  },
  async mounted() {
    // this.getEventStatus(); this is Event Type API call on page load
    this.setDefaultDates();
    await this.fetchCommentNoteStatuses();
    this.getEvents(false);
   
},
  watch: {
    selectedTimeFilter(newValue, oldValue) {
      // Automatically trigger search when Event Countdown filter changes
      if (newValue !== oldValue) {
        this.getEvents(true);
      }
    },
    JobIdStatus(newValue, oldValue) {
      // Prevent infinite loops
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return;

      // Define all values including blank (null)
      const allJobStatusValues = [
        'Blank',
        '1','2','3','4','5','6','7','8','9','10','11','12','13','14','15'
      ];

      // When Select All is added explicitly -> select everything (including blank)
      if (newValue.includes('selectAll') && !(oldValue || []).includes('selectAll')) {
        this.$nextTick(() => {
          this.JobIdStatus = ['selectAll', ...allJobStatusValues];
        });
        return;
      }

      // When Select All is removed explicitly by user -> clear everything
      if (!newValue.includes('selectAll') && (oldValue || []).includes('selectAll')) {
        const nonMarker = (newValue || []).filter(v => v !== 'selectAll');
        const allItemsStillSelected = allJobStatusValues.every(v => nonMarker.includes(v));
        if (allItemsStillSelected) {
          this.$nextTick(() => { this.JobIdStatus = []; });
          return;
        } else {
          // marker was auto-removed; just drop the marker
          this.$nextTick(() => { this.JobIdStatus = nonMarker; });
          return;
        }
      }

      // If user manually selected all items, add the marker
      const nonMarkerCount = (newValue || []).filter(v => v !== 'selectAll').length;
      if (!newValue.includes('selectAll') && nonMarkerCount === allJobStatusValues.length) {
        const allSelected = allJobStatusValues.every(v => (newValue || []).includes(v));
        if (allSelected) {
          this.$nextTick(() => { this.JobIdStatus = ['selectAll', ...allJobStatusValues]; });
        }
        return;
      }

      // If marker present but items fewer than full set -> remove marker
      if (newValue.includes('selectAll') && (newValue || []).filter(v => v !== 'selectAll').length < allJobStatusValues.length) {
        this.$nextTick(() => { this.JobIdStatus = (newValue || []).filter(v => v !== 'selectAll'); });
      }
    },
    NoteType(newValue, oldValue) {
      // Prevent infinite loops
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return;

      const allNoteValues = this.getAllNoteValues();

      // Select All added explicitly
      if (newValue.includes('selectAll') && !(oldValue || []).includes('selectAll')) {
        this.$nextTick(() => { this.NoteType = ['selectAll', ...allNoteValues]; });
        return;
      }

      // Select All removed explicitly -> clear all
      if (!newValue.includes('selectAll') && (oldValue || []).includes('selectAll')) {
        const nonMarker = (newValue || []).filter(v => v !== 'selectAll');
        const allItemsStillSelected = allNoteValues.every(v => nonMarker.includes(v));
        if (allItemsStillSelected) {
          this.$nextTick(() => { this.NoteType = []; });
          return;
        } else {
          this.$nextTick(() => { this.NoteType = nonMarker; });
          return;
        }
      }

      // If user manually selected all items -> add marker
      const nonMarkerCount = (newValue || []).filter(v => v !== 'selectAll').length;
      if (!newValue.includes('selectAll') && nonMarkerCount === allNoteValues.length) {
        const allSelected = allNoteValues.every(v => (newValue || []).includes(v));
        if (allSelected) this.$nextTick(() => { this.NoteType = ['selectAll', ...allNoteValues]; });
        return;
      }

      // If marker present but items fewer than full set -> remove marker
      if (newValue.includes('selectAll') && (newValue || []).filter(v => v !== 'selectAll').length < allNoteValues.length) {
        this.$nextTick(() => { this.NoteType = (newValue || []).filter(v => v !== 'selectAll'); });
      }
    },
    selectedDefaultOptions: {
      handler(newVal, oldVal) {
        if (this.shouldSkipWatch()) return;
        
        oldVal = oldVal || [];
        if (!Array.isArray(newVal)) return;
        if (this.updatingSelection) return;

        this.updatingSelection = true;

        const context = this.createSelectionContext(newVal, oldVal);

        // Handle different selection scenarios
        if (this.handleSelectAllAdded(context)) return;
        if (this.handleSelectAllToggled(context)) return;
        if (this.handleSelectAllRemoved(context)) return;
        if (this.handleEarningsParentAdded(context)) return;
        if (this.handleNonEarningsParentAdded(context)) return;
        if (this.handleEarningsParentToggled(context)) return;
        if (this.handleNonEarningsParentToggled(context)) return;
        if (this.handleEarningsParentRemoved(context)) return;
        if (this.handleNonEarningsParentRemoved(context)) return;
        if (this.cleanupSpecialValues(context.newVal)) return;

        // Auto-sync parent checkboxes based on children (use guarded helper)
        this.safeAutoSyncParentCheckboxes(context.newVal);

        this.finishUpdate();
      },
      deep: true
    }
  },
  methods: {
    getAllNoteValues() {
      const baseValues = ['Blank'];

      try {
        const statuses = Array.isArray(this.commentNoteStatuses)
          ? this.commentNoteStatuses
          : [];

        const apiValues = statuses
          .filter(status => status && status.statusValue)
          .map(status => status.statusValue);

        return [...baseValues, ...apiValues];
      } catch (error) {
        console.error('Error in getAllNoteValues:', error);
        return baseValues;
      }
    },

    fetchCommentNoteStatuses() {
      return axiosInstance
        .get(config.api_url + 'ConferenceCallTracker/GetCommentNoteStatuses')
        .then(response => {
          if (response.data?.success && Array.isArray(response.data.data)) {
            this.commentNoteStatuses = response.data.data;
          } else {
            this.commentNoteStatuses = [];
          }
        })
        .catch(error => {
          console.error('Error fetching comment note statuses:', error);
          this.commentNoteStatuses = [];
        });
    },

    //Event Type API method
    getEventStatus() {
      axiosInstance
        .get(config.api_url + "ConferenceCallTracker/GetEventTypes", {})
        .then((response) => {
          if (response.data.success) {
            // console.log(response.data.data);
            response.data.data.map((item) => {
              this.EventTypes = {
                text: item.eventType,
                value: item.eventTypeId,
              };
            });
          } else {
            this.setAlert(true, "Error Alert", response.data.message, "error");
          }
        })
        .catch((error) => {
          const errorMsg = error?.response?.data?.message || error?.message || "Failed to fetch event types";
          this.setAlert(true, "Error Alert", errorMsg, "error");
        });
    },

    handleUpdateDetails(updatedDetails) {
      this.uploadedDetails = updatedDetails;
    },
    handleshowModelLoader(showModelLoader) {
      this.showModelLoader = showModelLoader;
    },
    setDefaultDates() {
      const today = new Date();
      const formattedDate = moment(today).format("MMM D, YYYY");
      this.StartDate = formattedDate;
      this.EndDate = formattedDate;
    },
    refreshEvent() {
      //this.setDefaultDates();
      this.selectedTimeFilter = null;
      //this.getEvents(false);
      // Reload the page to reset everything to initial state
      window.location.reload();
    },
    onEventCountdownChange() {
      // Automatically trigger search when dropdown value changes
      this.getEvents(true);
    },
    setTimeFilter(hours) {
      // This method is no longer needed but keeping for backward compatibility
      this.selectedTimeFilter = hours;
      this.getEvents(true);
    },
    clearTimeFilter() {
      this.selectedTimeFilter = null;
      this.getEvents(true);
    },
    calculateTimeRange(hours) {
      // Get current system time
      const now = moment();
      
      // Calculate IST times (current time + hours ahead)
      // The filter should show events from NOW to NOW + hours
      const currentTimeIST = now.clone().utcOffset('+05:30');
      const endTimeIST = currentTimeIST.clone().add(parseInt(hours), 'hours');
      
      // Return the time range in IST format
      // Events with istDate >= currentTimeIST AND istDate <= endTimeIST should be shown
      return {
        start: currentTimeIST.format('YYYY-MM-DD HH:mm:ss'),
        end: endTimeIST.format('YYYY-MM-DD HH:mm:ss')
      };
    },
    applyTimeFilter(eventList) {
      // Return all events if no time filter is selected or if it's an empty string
      if (!this.selectedTimeFilter || String(this.selectedTimeFilter).trim() === "") {
        return eventList;
      }
      
      const timeRange = this.calculateTimeRange(this.selectedTimeFilter);
      const currentTimeIST = moment(timeRange.start, 'YYYY-MM-DD HH:mm:ss');
      const endTimeIST = moment(timeRange.end, 'YYYY-MM-DD HH:mm:ss');
      
      // Filter events that fall within the time range based on istDate column
      return eventList.filter(event => {
        if (!event.istDate) {
          return false; // Exclude events without istDate
        }
        
        // Parse the event's IST date time
        const eventISTDate = moment(event.istDate);
        
        // Check if event falls within the time window (current time to current time + hours)
        return eventISTDate.isSameOrAfter(currentTimeIST) && eventISTDate.isSameOrBefore(endTimeIST);
      });
    },
    chooseFiles(index) {
      this.clearSelectedFile();
      if (this.lastFileSelected != null) {
        this.clearSelectedFiles();
        this.enabledisableUpload(this.lastFileSelected, true, "");
      }
      document.getElementById("TranscribeFileInput" + index).accept =
        config.audioFileType;

      this.currentFileIndex = index;
      document.getElementById("TranscribeFileInput" + index).click();
    },
    clearSelectedFiles() {
      this.selectedFile = null;
      this.chooseFile = "";
    },
    enabledisableUpload(buttonIndex, value, controlValue) {
      const button = document.getElementById("TranscribeButton" + buttonIndex);
      if (button !== null) {
        if (value == false) {

          const event = this.eventList[buttonIndex];
          if (this.isTranscribeAllowed(event)) {
            document.getElementById("TranscribeButton" + buttonIndex).disabled =
              value;
          }
          else {

            document.getElementById("TranscribeButton" + buttonIndex).disabled = true;

          }

        }
        if (value == true) {
          document.getElementById("TranscribeButton" + buttonIndex).disabled = value;
        }

        if (controlValue != "NA") {
          document.getElementById("TranscribeFile" + buttonIndex).value =
            controlValue;
        }
      }
    },
    isTranscribeAllowed(event) {
      let eventUTC = '';
      const currentUTC = this.getCurrentUTC();
      if (event.istDate == null)
        eventUTC = this.convertToUTC(event.beginingDate);
      else
        eventUTC = this.convertISTToUTC(event.istDate);
      return currentUTC >= eventUTC;
    },
    getCurrentUTC() {
      const now = new Date();
      return now.toISOString();
    },
    convertToUTC(inputDate) {
      if (!inputDate) {
        return null;
      }
      let validDate = inputDate.trim();
      if (!validDate.endsWith("Z")) {
        validDate += "Z";
      }


      const localDate = new Date(validDate);
      if (isNaN(localDate.getTime())) {
        return null;
      }
      return localDate.toISOString();

    },
    convertISTToUTC(istDate) {

      const eventDate = new Date(istDate);
      const utcDate = eventDate.toISOString();

      return utcDate;
    },
    async handleFileChange(event) {
      // Handle file selection
      this.selectedFile = event.target.files[0];

      if (this.selectedFile) {
        this.chooseFile = this.selectedFile.name;
        this.enabledisableUpload(this.currentFileIndex, false, this.chooseFile);
        this.lastFileSelected = this.currentFileIndex;
      }
      else {
        this.enabledisableUpload(this.currentFileIndex, true, "");
      }
    },


    clearSelectedFile() {

      if (this.lastFileSelected != null) {
        const fileInput = this.$refs.fileInput[this.lastFileSelected];
        if (fileInput) {
          fileInput.value = null;
        }
      }
    },
    getParams() {
  // Convert NoteType text values to IDs for backend
  const noteTypeIds = this.NoteType
    .filter(v => v !== 'selectAll')
    .map(noteText => {
      if (noteText === 'Blank') return 'Blank';
      
      const status = this.commentNoteStatuses.find(s => s.statusValue === noteText);
      return status ? status.commentNoteId.toString() : null;
    })
    .filter(v => v !== null);
  
  const params = {
    EventId: this.EventId,
    EventType: this.selectedDefaultOptions.length == 0 ? "" : this.selectedDefaultOptions.toString(),
    CompanyId: this.CompanyId,
    StartDate: this.StartDate,
    EndDate: this.EndDate,
    Priority: this.Priority.length == 0 ? "" : this.Priority.toString(),
    FFPriority: this.FFPriority.length == 0 ? "" : this.FFPriority.toString(),
    IsReplayAvailable: this.IsReplayAvailable.length == 0 ? "" : this.IsReplayAvailable.toString(),
    IsPresentationAvailable: this.IsPresentationAvailable.length == 0 ? "" : this.IsPresentationAvailable.toString(),
    CollectionStatus: this.CollectionStatus.length == 0 ? "" : this.CollectionStatus.toString(),
    JobStatus: this.JobIdStatus.length == 0 ? "" : this.JobIdStatus.toString(),
    NoteType: noteTypeIds.length == 0 ? "" : noteTypeIds.toString(),
    sort: this.sortInfo,
    sortColumn: this.sortColumn,
    MatchStatus: this.MatchStatus.length == 0 ? "" : this.MatchStatus.toString(),
    TimeFilterStart: "",
    TimeFilterEnd: ""
  };
  
  // Add time filter only if a valid value is selected (not null, undefined, or empty string)
  if (this.selectedTimeFilter != null && String(this.selectedTimeFilter).trim() !== "") {
    const timeRange = this.calculateTimeRange(this.selectedTimeFilter);
    params.TimeFilterStart = timeRange.start;
    params.TimeFilterEnd = timeRange.end;
  }
  
  return params;
},
    getEvents(resetpage) {
      this.showModelLoader = true;
      axiosInstance
        .get(config.api_url + "ConferenceCallTracker/EventDetails", {
          params: {
            ...this.getParams(),
            pageIndex: this.DefaultPageIndex,
            pageSize: this.DefaultPageSize
          },
        })
        .then((response) => {
          if (response.data.success) {
          this.eventList = response.data.data.eventList;
          this.totalRecord = response.data.data.totalRecords;
            if (this.totalRecord != 0) {
              if (resetpage) {
                this.paginationOptions.page = 1;
              }
              this.showPagination = true;
            } else {
              this.showPagination = false;
            }
            this.eventList.forEach((event) => {
              event.textValue = event.documentIds && Array.isArray(event.documentIds)
                ? event.documentIds.join(', ') // Convert documentIds array to a comma-separated string
                : ''; // If documentIds is not an array, set textValue as an empty string
              event.isEditing = false;
              
              // Backend sends commentNote as ID - set both ID and text value
              //const noteId = event.commentNote ? Number(event.commentNote) : null;
              //event.commentNoteId = (noteId && noteId !== 0) ? noteId : null;
              
               if (!event.commentNoteId && event.commentNote) {

                event.commentNoteId = Number(event.commentNote);

              }

              

              event.commentNoteId = (event.commentNoteId && event.commentNoteId !== 0) ? Number(event.commentNoteId) : null;

              // Also set the text value for tooltip and display
              if (event.commentNoteId) {
                const status = this.commentNoteStatuses.find(s => s.commentNoteId == event.commentNoteId);
                event.commentNote = status ? status.statusValue : "";
              } else {
                event.commentNote = "";
              }
              
              // Debug logging
              console.log('Event:', event.eventId, 'commentNoteId:', event.commentNoteId, 'commentNote:', event.commentNote);
            });
            
            // Debug: log available options
            console.log('Available comment note statuses:', this.commentNoteStatuses);
            console.log('Computed commentNoteOptions:', this.commentNoteOptions);
          } else {
            this.setAlert(true, "Error Alert", response.data.message, "error");
          }
          this.showModelLoader = false;
        })
        .catch((error) => {
          const errorMsg = error?.response?.data?.message || error?.message || "Failed to fetch event details";
          this.setAlert(true, "Error Alert", errorMsg, "error");
          this.showModelLoader = false;
        });
    },
    exportEvents(resetpage) {
      this.showModelLoader = true;
      axiosInstance
        .get(config.api_url + "ConferenceCallTracker/ExportToExcel", {
          responseType: 'blob',
          params: this.getParams(),
        })
        .then((response) => {

          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, 'ConferenceCallDetails.xlsx', {
            type: 'text/plain;charset=windows-1252'
          });
          this.showModelLoader = false;
        })
        .catch((error) => {
          const errorMsg = error?.response?.data?.message || error?.message || "Failed to export data";
          this.setAlert(true, "Error Alert", errorMsg, "error");
          this.showModelLoader = false;
        });
    },
    handlePageChange(paginationOptions) {
      this.paginationOptions = paginationOptions;
      this.DefaultPageIndex = paginationOptions.page;
      this.DefaultPageSize = paginationOptions.pageSize;
      this.eventList.forEach((event, index) => {
        this.enabledisableUpload(index, true, "");
      });
      this.getEvents(false);
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
    toggleEdit(event) {
      event.isEditing = !event.isEditing;
    },
    toggleTooltip(nativeEvent, show, eventItemIndex, eventId) {
      this.showTooltip = show;
      this.showTooltipId = this.NoteId + eventItemIndex;
      if (show && nativeEvent && nativeEvent.currentTarget) {
        const rect = nativeEvent.currentTarget.getBoundingClientRect();
        this.tooltipPosition = {
          top: rect.bottom + 4,
          left: rect.left
        };
      }
    }
    ,
    openModel(eventId, webcastUrl, eventName) {
      this.toggle = !this.toggle;
      this.eventIdProp = eventId;
      this.eventNameProp = eventName;
      this.webcastUrl = webcastUrl;
      if (this.webcastUrl === null || this.webcastUrl === "") {
        this.webcastUrl = null;
      }
      this.showModelLoader = true;
      axiosInstance
        .get(
          `${config.api_url}ConferenceCallTracker/get-upload-data?eventId=${this.eventIdProp}&webcastUrl=${this.webcastUrl}`
        )
        .then((response) => {
          if (response.data.success)
            this.uploadedDetails = response.data.data.uploadedData;
          else
            this.setAlert(true, "Error Alert", response.data.message, "error");
        })
        .catch((error) => {
          const errorMsg = error?.response?.data?.message || error?.message || "Failed to fetch upload data";
          this.setAlert(true, "Error Alert", errorMsg, "error");
        })
        .finally(() => {
          this.showModelLoader = false;
        });
    },
    formatDate(date) {
      var formatedDate = moment(date).format("YYYY-MM-DD");
      return formatedDate;
    },
    formatISTDate(datevalue) {
      if (datevalue) {
        var formatedISTDate = moment(datevalue).format("YYYY-MM-DD HH:mm:ss");
        return formatedISTDate;
      } else {
        return '';
      }
    },
    setComment() {

    }
    , setAlert(flag, tile, message, varation) {
      this.showAlert = flag;
      this.alertTitle = tile;
      this.alertMessage = message;
      this.alertVariation = varation;
      window.scrollTo(0, 0);
      if (flag) this.autoCloseAlert();
    },
    closeCommentModal() {

    },
    closeAlert() {
      this.setAlert(false, "", "", "");
      if (this.alertTimer) clearTimeout(this.alertTimer);
    },
    autoCloseAlert() {
      this.alertTimer = setTimeout(() => {
        this.closeAlert();
      }, config.alertTime * 1000);
    },
    getFileBaseName(fileName) {
      if (!fileName) return "";
      const idx = fileName.lastIndexOf(".");
      return idx === -1 ? fileName : fileName.substring(0, idx);
    },

    // Validate that base name matches EventId
    isAudioFileNameValidForEvent(fileName, eventId) {
      const base = this.getFileBaseName(fileName);
      return base === String(eventId);
    },
    async UploadTranscribe(
      priority,
      index,
      EventId,
      EventType,
      CompanyId,
      CompanyName,
      BeginingDate
    ) {
      // Validation 1: Select file
      if (this.selectedFile == "" || this.selectedFile == null) {
        this.setAlert(true, "Warning Alert", "Please Choose File", "warning");
        return;
      }
      // Validation 2: Only Audio and Video File
      if (this.selectedFile) {
        const arrfileExt = config.audioFileType.replaceAll(".", "").split(",");
        var ext = this.selectedFile.name.split(".").pop();
        if (!arrfileExt.includes(ext)) {
          this.setAlert(
            true,
            "Warning Alert",
            ext + " this file not supported, only allowed " + arrfileExt,
            "warning"
          );
          return;
        }
      }

      // Validation 3: Audio filename must match Event ID
      if (!this.isAudioFileNameValidForEvent(this.selectedFile.name, EventId)) {
         this.setAlert(true, "Warning Alert", "Audio name is not matching with event ID.", "warning"); 
        return;
      }
      
      try {
        this.showModelLoader = true;
        const apiUrl = `${config.api_url}ConferenceCallTracker/transcribe`;
        const createdByValue = parseInt(this.userDetails.data.userId, 10);
        const formData = new FormData();
        formData.append("Priority", priority);
        formData.append("EventId", EventId);
        formData.append("EventType", EventType);
        formData.append("CompanyId", CompanyId);
        formData.append("CompanyName", CompanyName);
        formData.append("EventDate", BeginingDate);
        formData.append("FilePurpose", "audio_processing");
        formData.append("FileFormat", ext);
        formData.append("createdBy", createdByValue);
        formData.append("File", this.selectedFile);

        const response = await axiosInstance.post(apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.data.success) {
          await this.getEvents(false);
          this.setAlert(true, "Success Alert", "Success", "success");
          this.showModelLoader = false;
        } else {
          this.setAlert(true, "Error Alert", response.data.message, "error");
          this.showModelLoader = false;
        }
      } catch (error) {
        const errorMsg = error?.message || "Upload failed";
        this.setAlert(true, "Error Alert", errorMsg, "error");
        this.showModelLoader = false;
      } finally {
        if (this.connection) {
          this.clearSelectedFiles();
          await this.connection.stop();
        }
        this.clearSelectedFiles();
        this.enabledisableUpload(index, true, "NA");
      }
    },
    OnCommentSubmit() {
      if (this.commentText.trim() === "") {
        this.setAlert(true, "Warning Alert", "Please enter a comment.", "warning");
        return;
      }
      this.showModelLoader = true;

      const eventIndex = this.eventList.findIndex(e => e.eventId === this.EventComment.EventId);
      if (eventIndex !== -1) {
        // Find "Other" status ID
        const otherStatus = this.commentNoteStatuses.find(s => s.statusValue === "Other");
        this.eventList[eventIndex].comment = this.commentText;
        this.eventList[eventIndex].commentNote = "Other";
        this.eventList[eventIndex].commentNoteId = otherStatus ? otherStatus.commentNoteId : null;
      }
      this.CommentModalToggle = false;

      this.showModelLoader = false;
      
    },
    ToggleCommentModal() {
      this.CommentModalToggle = !this.CommentModalToggle;
    },
    NoteChanged(event,index, EventId) {
      var selectedNoteId = document.getElementById(
        this.NoteId + index
      ).value;
      if (selectedNoteId == "" || selectedNoteId == null) { }
      else {
        // Find the status object to get both ID and text
        const selectedStatus = this.commentNoteStatuses.find(s => s.commentNoteId == selectedNoteId);
        const selectedNoteText = selectedStatus ? selectedStatus.statusValue : "";
        
        this.EventComment.EventId = EventId;
        this.EventComment.CreatedBy = parseInt(this.userDetails.data.userId, 10);
        this.EventComment.NoteId = selectedNoteId;
        this.EventComment.Note = selectedNoteText;

        // Check if "Other" is selected - compare text value
        if (selectedNoteText === "Other") {
          this.commentText = "";
          this.ToggleCommentModal();
        }
        else {
          this.eventList[index].comment = "";
          this.eventList[index].commentNoteId = Number(selectedNoteId);
          this.eventList[index].commentNote = selectedNoteText;
        }
      }
    },
    saveStatus(index, EventId, DocumentIds) {
      this.closeAlert();
        const rawTextValue = DocumentIds || "";

        const documentIds = rawTextValue
          .split(",")
          .map(id => id.trim())
          .filter(id => id !== "")
          .map(id => {
            const parsed = parseInt(id, 10);
            return isNaN(parsed) ? null : parsed;
          });

        const uniqueIds = new Set(documentIds);
        if (uniqueIds.size !== documentIds.length) {
          this.setAlert(
            true,
            "Warning Alert",
            "Document IDs cannot contain duplicates.",
            "warning"
          );
          return;
        }
        if (documentIds.some(id => id === 0)) {
          this.setAlert(
            true,
            "Warning Alert",
            "Document ID cannot be zero.",
            "warning"
          );
          return;
        }

        this.EventStatus.EventId = EventId;
        this.showModelLoader = true;
        this.EventStatus.DocumentIds = documentIds;
        this.EventStatus.CreatedBy = parseInt(this.userDetails.data.userId, 10);

        this.EventStatus.Comment = this.eventList[index].comment;
        this.EventStatus.Note = this.eventList[index].commentNote;
        this.EventStatus.CommentNoteId = this.eventList[index].commentNoteId ?? 0;

        axiosInstance
          .post(
            config.api_url + "ConferenceCallTracker/SaveEventStatus",
            this.EventStatus
          )
          .then((response) => {
            if (response.data.success) {
              if (response.data.data == "Validation")
                this.setAlert(
                  true,
                  "Warning Alert",
                  response.data.message,
                  "warning"
                );
              else
                this.setAlert(
                  true,
                  "Success Alert",
                  response.data.message,
                  "success"
                );
              this.eventList[index].isEditing = false;

            } else
              this.setAlert(
                true,
                "Error Alert",
                response.data.message,
                "error"
              );
            this.showModelLoader = false;
          })
          .catch((error) => {
            this.setAlert(true, "Error Alert", error.response, "error");
            this.showLoader = false;
          });
    },
    getSortedData(event) {
      this.sortInfo = event.currentTarget.value.includes("Desc") ? "DESC" : "ASC";
      this.sortColumn = event.currentTarget.value.replace(/Desc|Asc/g, '').length > 1 ? event.currentTarget.value.replace(/Desc|Asc/g, '') : "beginingDate";
      this.getEvents(false);
    },
    fetchEventActionLog(eventId) {
          // Reset to first page only when opening the modal
          if (!this.showActionLogModal) {
            this.actionLogPageIndex = 1;
            this.actionLogPageSize = 5;
            this.actionLog = [];
            this.totalActionLogCount = 0;
            this.showActionLogPagination = false;
            this.showActionLogModal = true;
          }
          this.currentActionLogEventId = eventId;
          this.actionLogLoading = true;
          axiosInstance
            .get(config.api_url + "ConferenceCallTracker/EventActionLog", {
              params: { eventId, pageIndex: this.actionLogPageIndex, pageSize: this.actionLogPageSize }
            })
            .then((r) => {
              if (!r.data?.success) {
                this.setAlert(true, "Error Alert", r.data?.message || "Failed to load action log", "error");
                return;
              }
              const list = r.data.data.eventList || [];
              const total = r.data.data.totalRecords || list.length;
              this.actionLog = list;
              this.totalActionLogCount = total;
              this.showActionLogPagination = total > 5;
              if (list.length === 0) {
                this.setAlert(true, "Info Alert", "No action log found.", "info");
              }
            })
            .catch((error) => {
              this.setAlert(true, "Error Alert", error.response || error, "error");
            })
            .finally(() => {
              this.actionLogLoading = false;
            });
    },
    fetchCompanyUrls(companyId) {
      if (!companyId) {
        this.setAlert(true, "Error Alert", "Company ID is required", "error");
        return;
      }
      
      this.showModelLoader = true;
      axiosInstance
        .get(config.api_url + "ManageEventCalendar/ManageURLInfo", {
          params: { companyId }
        })
        .then((response) => {
          if (response.data?.success) {
            const urls = response.data.data || [];
            if (urls.length === 0) {
              this.setAlert(true, "Warning Alert", "No URLs found for this company", "warning");
            } else {
              // Open all URLs in new tabs
              urls.forEach((url) => {
                if (url) {
                  window.open(url, '_blank');
                }
              });
              this.setAlert(true, "Success Alert", `Opened ${urls.length} URL(s) in new tabs`, "success");
            }
          } else {
            this.setAlert(true, "Error Alert", response.data?.message || "Failed to fetch URLs", "error");
          }
        })
        .catch((error) => {
          const errorMsg = error?.response?.data?.message || error?.message || "Failed to fetch company URLs";
          this.setAlert(true, "Error Alert", errorMsg, "error");
        })
        .finally(() => {
          this.showModelLoader = false;
        });
    },
    handleActionLogPageChange(paginationOptions) {
      this.actionLogPageIndex = paginationOptions.page;
      this.actionLogPageSize = paginationOptions.pageSize;
      this.fetchEventActionLog(this.currentActionLogEventId);
    },
    formatActionDate(date) {
      if (!date) return '';
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    
    // Mismatched Modal Methods
    openMismatchedModal(event) {
      this.selectedMismatchedEvent = event;
      this.MismatchedModalToggle = true;
    },
    
    confirmMatch() {
      if (!this.selectedMismatchedEvent) {
        this.setAlert(true, "Error Alert", "No event selected", "error");
        return;
      }
      
      this.showModelLoader = true;
      
      // API call to update match status
      const matchStatusDto = {
        EventId: this.selectedMismatchedEvent.eventId,
        JobId: this.selectedMismatchedEvent.jobId,
        IsMatched: true,
        UpdatedBy: parseInt(this.userDetails.data.userId, 10)
      };
      
      axiosInstance
        .post(config.api_url + "ConferenceCallTracker/update-match-status", matchStatusDto)
        .then((response) => {
          if (response.data.success) {
            this.getEvents(false);
            this.setAlert(true, "Success Alert", "Event matched successfully", "success");
            this.MismatchedModalToggle = false;
            this.selectedMismatchedEvent = null;
          } else {
            // Close modal so alert is visible on top
            this.MismatchedModalToggle = false;
            this.selectedMismatchedEvent = null;
             const errorMessage = response.data.data?.message || response.data.message || "Failed to update match status";
             this.setAlert(true, "Error Alert", errorMessage, "error");
          }
          this.showModelLoader = false;
        })
        .catch((error) => {
          // For HTTP 400 or other errors, ensure modal is closed and error is shown
          this.MismatchedModalToggle = false;
          this.selectedMismatchedEvent = null;
          let message = "Failed to update match status";
          if (error && error.response && error.response.data) {
            if (error.response.data.data && error.response.data.data.message) {
              message = error.response.data.data.message;
            }
            else if (error.response.data.message) {
              message = error.response.data.message;
            }
          }
          else if (error && error.message) {
            message = error.message;
          }
          this.setAlert(true, "Error Alert", message, "error");
          this.showModelLoader = false;
        });
    },
    
    cancelMatch() {
      this.MismatchedModalToggle = false;
      this.selectedMismatchedEvent = null;
    },
    selectAllDefaults() {
      // Select all configured default values
      this.selectedDefaultOptions = [...this.allDefaultValues];
    },
    clearAllDefaults() {
      this.selectedDefaultOptions = [];
    },
    selectAllEarnings() {
      const earningsValues = Array.isArray(this.earningsValues) ? this.earningsValues : [];
      const otherValues = this.selectedDefaultOptions.filter(v => !earningsValues.includes(v));
      this.selectedDefaultOptions = [...otherValues, ...earningsValues];
    },

    // Helper methods for selectedDefaultOptions refactoring
    shouldSkipWatch() {
      return this.isClearingAll;
    },

    createSelectionContext(newVal, oldVal) {
      return {
        newVal,
        oldVal,
        selectAllInNew: newVal.includes(this.SPECIAL_VALUES.SELECT_ALL),
        earningsParentInNew: newVal.includes(this.SPECIAL_VALUES.EARNINGS_PARENT),
        nonEarningsParentInNew: newVal.includes(this.SPECIAL_VALUES.NON_EARNINGS_PARENT),
        selectAllWasInOld: oldVal.includes(this.SPECIAL_VALUES.SELECT_ALL),
        earningsParentWasInOld: oldVal.includes(this.SPECIAL_VALUES.EARNINGS_PARENT),
        nonEarningsParentWasInOld: oldVal.includes(this.SPECIAL_VALUES.NON_EARNINGS_PARENT)
      };
    },

    handleSelectAllAdded(context) {
      if (context.selectAllInNew && !this.selectAllChecked) {
        this.selectAllChecked = true;
        this.earningsParentChecked = true;
        this.nonEarningsParentChecked = true;
        this.selectedDefaultOptions = [...this.allDefaultValues];
        this.finishUpdate();
        return true;
      }
      return false;
    },

    handleSelectAllToggled(context) {
      if (context.selectAllInNew && this.selectAllChecked) {
        this.clearAllSelections();
        return true;
      }
      return false;
    },

    handleSelectAllRemoved(context) {
      if (!context.selectAllInNew && this.selectAllChecked) {
        if (context.selectAllWasInOld) {
          this.clearAllSelections();
          return true;
        } else {
          this.selectAllChecked = false;
        }
      }
      return false;
    },

    handleEarningsParentAdded(context) {
      if (context.earningsParentInNew && !this.earningsParentChecked) {
        this.earningsParentChecked = true;
        const otherValues = this.filterOutValues(context.newVal, [
          ...this.earningsValues,
          this.SPECIAL_VALUES.EARNINGS_PARENT,
          this.SPECIAL_VALUES.SELECT_ALL
        ]);
        this.selectedDefaultOptions = [...otherValues, ...this.earningsValues];
        this.finishUpdate();
        return true;
      }
      return false;
    },

    handleNonEarningsParentAdded(context) {
      if (context.nonEarningsParentInNew && !this.nonEarningsParentChecked) {
        this.nonEarningsParentChecked = true;
        const otherValues = this.filterOutValues(context.newVal, [
          ...this.nonEarningsValues,
          this.SPECIAL_VALUES.NON_EARNINGS_PARENT,
          this.SPECIAL_VALUES.SELECT_ALL,
          this.SPECIAL_VALUES.EARNINGS_PARENT
        ]);
        this.selectedDefaultOptions = [...otherValues, ...this.nonEarningsValues];
        this.finishUpdate();
        return true;
      }
      return false;
    },

    handleEarningsParentToggled(context) {
      if (context.earningsParentInNew && this.earningsParentChecked) {
        this.earningsParentChecked = false;
        const filtered = this.filterOutValues(context.newVal, [
          ...this.earningsValues,
          this.SPECIAL_VALUES.EARNINGS_PARENT,
          this.SPECIAL_VALUES.SELECT_ALL
        ]);
        this.selectedDefaultOptions = filtered;
        this.finishUpdate();
        return true;
      }
      return false;
    },

    handleNonEarningsParentToggled(context) {
      if (context.nonEarningsParentInNew && this.nonEarningsParentChecked) {
        this.nonEarningsParentChecked = false;
        const filtered = this.filterOutValues(context.newVal, [
          ...this.nonEarningsValues,
          this.SPECIAL_VALUES.NON_EARNINGS_PARENT,
          this.SPECIAL_VALUES.SELECT_ALL,
          this.SPECIAL_VALUES.EARNINGS_PARENT
        ]);
        this.selectedDefaultOptions = filtered;
        this.finishUpdate();
        return true;
      }
      return false;
    },

    handleEarningsParentRemoved(context) {
      if (!context.earningsParentInNew && this.earningsParentChecked && context.earningsParentWasInOld) {
        this.earningsParentChecked = false;
        const filtered = this.filterOutValues(context.newVal, [
          ...this.earningsValues,
          this.SPECIAL_VALUES.EARNINGS_PARENT,
          this.SPECIAL_VALUES.SELECT_ALL
        ]);
        this.selectedDefaultOptions = filtered;
        this.finishUpdate();
        return true;
      } else if (!context.earningsParentInNew && this.earningsParentChecked && !context.earningsParentWasInOld) {
        this.earningsParentChecked = false;
      }
      return false;
    },

    handleNonEarningsParentRemoved(context) {
      if (!context.nonEarningsParentInNew && this.nonEarningsParentChecked && context.nonEarningsParentWasInOld) {
        this.nonEarningsParentChecked = false;
        const filtered = this.filterOutValues(context.newVal, [
          ...this.nonEarningsValues,
          this.SPECIAL_VALUES.NON_EARNINGS_PARENT,
          this.SPECIAL_VALUES.SELECT_ALL,
          this.SPECIAL_VALUES.EARNINGS_PARENT
        ]);
        this.selectedDefaultOptions = filtered;
        this.finishUpdate();
        return true;
      } else if (!context.nonEarningsParentInNew && this.nonEarningsParentChecked && !context.nonEarningsParentWasInOld) {
        this.nonEarningsParentChecked = false;
      }
      return false;
    },

    cleanupSpecialValues(newVal) {
      const hasSpecialValues = Object.values(this.SPECIAL_VALUES).some(v => newVal.includes(v));
      if (hasSpecialValues) {
        const cleanedValues = this.filterOutValues(newVal, Object.values(this.SPECIAL_VALUES));
        this.selectedDefaultOptions = cleanedValues;
        this.finishUpdate();
        return true;
      }
      return false;
    },

    autoSyncParentCheckboxes(newVal) {
      // Sync earnings parent
      const earningsChildrenSelected = this.earningsValues.filter(v => newVal.includes(v));
      if (earningsChildrenSelected.length === this.earningsValues.length && !this.earningsParentChecked) {
        this.earningsParentChecked = true;
      } else if (earningsChildrenSelected.length < this.earningsValues.length && this.earningsParentChecked) {
        this.earningsParentChecked = false;
      }

      // Sync non-earnings parent
      const nonEarningsChildrenSelected = this.nonEarningsValues.filter(v => newVal.includes(v));
      if (nonEarningsChildrenSelected.length === this.nonEarningsValues.length && !this.nonEarningsParentChecked) {
        this.nonEarningsParentChecked = true;
      } else if (nonEarningsChildrenSelected.length < this.nonEarningsValues.length && this.nonEarningsParentChecked) {
        this.nonEarningsParentChecked = false;
      }

      // Sync select all
      const allItemsSelected = this.allDefaultValues.every(v => newVal.includes(v));
      if (allItemsSelected && !this.selectAllChecked) {
        this.selectAllChecked = true;
        if (!newVal.includes(this.SPECIAL_VALUES.SELECT_ALL)) {
          this.selectedDefaultOptions = [...newVal, this.SPECIAL_VALUES.SELECT_ALL];
          this.finishUpdate();
        }
      } else if (!allItemsSelected && this.selectAllChecked) {
        this.selectAllChecked = false;
        if (newVal.includes(this.SPECIAL_VALUES.SELECT_ALL)) {
          const filtered = newVal.filter(v => v !== this.SPECIAL_VALUES.SELECT_ALL);
          this.selectedDefaultOptions = filtered;
          this.finishUpdate();
        }
      }
    },

    safeAutoSyncParentCheckboxes(newVal) {
      const earningsVals = Array.isArray(this.earningsValues) ? this.earningsValues : [];
      if (earningsVals.length > 0) {
        const earningsChildrenSelected = earningsVals.filter(v => newVal.includes(v));
        this.earningsParentChecked = earningsChildrenSelected.length === earningsVals.length;
      }

      const nonEarningsVals = Array.isArray(this.nonEarningsValues) ? this.nonEarningsValues : [];
      if (nonEarningsVals.length > 0) {
        const nonEarningsChildrenSelected = nonEarningsVals.filter(v => newVal.includes(v));
        this.nonEarningsParentChecked = nonEarningsChildrenSelected.length === nonEarningsVals.length;
      }

      const allDefaultVals = Array.isArray(this.allDefaultValues) ? this.allDefaultValues : [];
      if (allDefaultVals.length > 0) {
        const allItemsSelected = allDefaultVals.every(v => newVal.includes(v));
        this.selectAllChecked = allItemsSelected;
      }
    },

    filterOutValues(array, valuesToFilter) {
      return array.filter(v => !valuesToFilter.includes(v));
    },

    clearAllSelections() {
      this.isClearingAll = true;
      this.selectAllChecked = false;
      this.earningsParentChecked = false;
      this.nonEarningsParentChecked = false;
      this.selectedDefaultOptions = [];
      this.$nextTick(() => {
        this.isClearingAll = false;
        this.updatingSelection = false;
      });
    },

    finishUpdate() {
      this.$nextTick(() => {
        this.updatingSelection = false;
      });
    },
  },
  computed: {
    ...mapState("auth", {
      userDetails: (state) => state.userDetails,
    }),

    commentNoteOptions() {
      try {
        const statuses = this.commentNoteStatuses || [];
        if (Array.isArray(statuses) && statuses.length > 0) {
          return statuses
            .filter(status => status && status.statusValue)
            .map(status => ({
              text: status.statusValue,
              value: status.commentNoteId
            }));
        }
      } catch (error) {
        console.error('Error in commentNoteOptions:', error);
        return [];
      }
      
      return [];
    },

    commentNoteDataSet() {
      const baseOptions = [
        { text: 'Select All', value: 'selectAll' },
        { text: 'Blank', value: 'Blank' }
      ];
      
      try {
        const statuses = this.commentNoteStatuses || [];
        if (Array.isArray(statuses) && statuses.length > 0) {
          const apiOptions = statuses
            .filter(status => status && status.statusValue)
            .map(status => ({
              text: status.statusValue,
              value: status.statusValue
            }));
          
          return [...baseOptions, ...apiOptions];
        }
      } catch (error) {
        console.error('Error in commentNoteDataSet:', error);
        return baseOptions;
      }
      
      return baseOptions;
    },

    paginatedData() {
      const start = this.paginationOptions
        ? this.paginationOptions.firstItem - 1
        : 0;
      const end =
        this.paginationOptions && this.paginationOptions.pageSize !== -1
          ? start + this.paginationOptions.pageSize
          : this.eventList.length;
      return this.eventList.slice(start, end);
    },
  },
};
</script>
<style lang="scss" module>
*,
#fieldset1::before,
#fieldset1::after {
  margin-right: 15px;
}

.round {
  border-radius: 24px;
}

.round:before {
  border-radius: 50%;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    background-color: #ccc;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.4s;
    border-radius: 24px;

    &::before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      transition: 0.4s;
      border-radius: 50%;
    }
  }

  input:checked+.slider {
    background-color: #2196F3;

    &::before {
      transform: translateX(20px);
    }
  }
}

.doc-textarea:disabled {
  cursor: not-allowed;
  background-color: #f0f0f0;
}
.hover-box {
  position: relative;
  display: inline-block;
}
.tooltip {
  position: fixed;
  background-color: black;
  color: white;
  padding: 6px 10px;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 400px;
  z-index: 9999;
  pointer-events: none;
}

</style>

